(function () {
  if (window.__noendyHover) return;
  window.__noendyHover = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  /* ----- Card spotlight (mouse-follow gradient overlay) ----- */
  const SPOTLIGHT_SELECTOR = '.noendy-age-card, .noendy-bundle-card, .noendy-package-card, .noendy-value-card, .noendy-testimonial-card, .noendy-how-step, .noendy-team-card';

  function trackSpotlight(el) {
    if (el._noendySpotlight) return;
    el._noendySpotlight = true;
    let raf;
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.setProperty('--noendy-spotlight-x', x + '%');
        el.style.setProperty('--noendy-spotlight-y', y + '%');
      });
    });
  }

  /* ----- Magnetic effect on primary CTAs -----
     Hero buttons çıkarıldı — hero motion'u admin'in "Buton hover efekti"
     ayarına (global veya section override) bırakıldı. */
  const MAGNETIC_SELECTOR = '.noendy-popup__submit, .noendy-cookie__btn--primary, .noendy-package-card.is-featured .noendy-package-card__cta';
  const MAGNETIC_STRENGTH = 0.22;

  function trackMagnetic(el) {
    if (el._noendyMagnetic) return;
    el._noendyMagnetic = true;
    let raf;
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.transform = `translate(${x * MAGNETIC_STRENGTH}px, ${y * MAGNETIC_STRENGTH}px) translateY(-2px)`;
      });
    });
    el.addEventListener('mouseleave', () => {
      if (raf) cancelAnimationFrame(raf);
      el.style.transform = '';
    });
  }

  /* ----- 3D tilt on cards (subtle parallax) ----- */
  const TILT_SELECTOR = '.noendy-age-card, .noendy-bundle-card, .noendy-package-card, .noendy-stat-item';
  const TILT_MAX_ANGLE = 4;

  function trackTilt(el) {
    if (el._noendyTilt) return;
    el._noendyTilt = true;
    let raf;
    let isHovering = false;

    el.addEventListener('mouseenter', () => {
      isHovering = true;
      el.style.transition = 'transform 0.12s linear, box-shadow 0.3s ease';
    });

    el.addEventListener('mousemove', (e) => {
      if (!isHovering) return;
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const cx = rect.width / 2;
      const cy = rect.height / 2;
      const rotateX = ((cy - y) / cy) * TILT_MAX_ANGLE;
      const rotateY = ((x - cx) / cx) * TILT_MAX_ANGLE;

      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-6px) scale(1.01)`;
      });
    });

    el.addEventListener('mouseleave', () => {
      isHovering = false;
      if (raf) cancelAnimationFrame(raf);
      el.style.transition = '';
      el.style.transform = '';
    });
  }

  /* ----- Parallax image shift on product card hover ----- */
  const PARALLAX_SELECTOR = '.card-wrapper, .product-card-wrapper';
  const PARALLAX_STRENGTH = 6;

  function trackParallax(el) {
    if (el._noendyParallax) return;
    el._noendyParallax = true;
    const img = el.querySelector('.card__media img');
    if (!img) return;
    let raf;
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width - 0.5) * PARALLAX_STRENGTH;
      const y = ((e.clientY - rect.top) / rect.height - 0.5) * PARALLAX_STRENGTH;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        img.style.transform = `scale(1.08) translate(${x}px, ${y}px)`;
      });
    });
    el.addEventListener('mouseleave', () => {
      if (raf) cancelAnimationFrame(raf);
      img.style.transform = '';
    });
  }

  /* ----- Init & re-init on shopify:section:load ----- */
  function init() {
    document.querySelectorAll(SPOTLIGHT_SELECTOR).forEach(trackSpotlight);
    document.querySelectorAll(MAGNETIC_SELECTOR).forEach(trackMagnetic);
    document.querySelectorAll(TILT_SELECTOR).forEach(trackTilt);
    document.querySelectorAll(PARALLAX_SELECTOR).forEach(trackParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
